import React from 'react';

export function ViewPackagingPOV2() {
    return (
        <div className="flex min-h-screen flex-col">
            <div className="px-4 pt-4">
                <h1 className="text-xl font-semibold">Packaging Purchase Orders V2</h1>
            </div>
            <div className="flex flex-1 flex-col px-4 pb-6 pt-4">
                <div className="rounded-md border border-dashed border-muted-foreground/30 p-6 text-sm text-muted-foreground">
                    Placeholder page for the packaging PO v2 list view.
                </div>
            </div>
        </div>
    );
}

ViewPackagingPOV2.displayName = 'ViewPackagingPOV2';
